import axios from 'axios';
import _ from 'lodash';

const SPEAKERS_API = 'https://rdbj3n0snd.execute-api.us-east-1.amazonaws.com/prod';
const TALKS_API = 'https://5dhdj4hqc9.execute-api.us-east-1.amazonaws.com/prod';
const SPEAKER_DETAILS_API = 'https://odmlr3damg.execute-api.us-east-1.amazonaws.com/develop';
const TALK_DETAILS_API = 'https://0ybabwzuu2.execute-api.us-east-1.amazonaws.com/develop';
const FEEDBACK_API = 'https://rska3uuwcj.execute-api.us-east-1.amazonaws.com/develop';
const CALL_FOR_SPEAKERS_API = 'https://d63fudnvzk.execute-api.us-east-1.amazonaws.com/develop';

const sendAPIRequest = async ({ method = 'GET', url, data }) => {
  try {
    return await axios({
      method,
      url,
      data
    });
  } catch (error) {
    throw new Error(error);
  }
};

export const submitCallForSpeakers = async formData => {
  const data = Object.keys(formData).reduce((prev, field) => {
    const tempPrev = prev;

    if (field === 'speakers') {
      tempPrev.speakers = formData.speakers.map(speaker => ({
        speakerName: speaker.speakerName.value,
        email: speaker.email.value,
        company: speaker.company.value,
        country: speaker.country.value,
        speakerBio: speaker.speakerBio.value.replaceAll('"', '“'),
        photo: speaker.photo.value
      }));
      return tempPrev;
    }

    if (field === 'stream') {
      tempPrev[field] = formData[field].value;
    } else if (typeof formData[field].value === 'string') {
      tempPrev[field] = _.escape(formData[field].value.replaceAll('"', '“'));
    } else {
      tempPrev[field] = _.escape(formData[field].value);
    }

    return tempPrev;
  }, {});

  return sendAPIRequest({
    method: 'POST',
    url: `${CALL_FOR_SPEAKERS_API}/cfs`,
    data
  });
};

export const submitConferenceFF = async data =>
  sendAPIRequest({
    method: 'POST',
    url: `${FEEDBACK_API}/feedback-forms/conference`,
    data
  });

// export const submitWorkshopFF = async data =>
//   sendAPIRequest({
//     method: 'POST',
//     url: `${FEEDBACK_API}/feedback-forms/workshops`,
//     data
//   });

export const getSpeakers = async () => {
  try {
    const speakers = await axios.get(`${SPEAKERS_API}/speakers`);
    const data =
      typeof speakers.data === 'string'
        ? JSON.parse(speakers.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
        : speakers.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTalks = async () => {
  try {
    const talks = await axios.get(`${TALKS_API}/talks`);
    const data =
      typeof talks.data === 'string'
        ? JSON.parse(talks.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
        : talks.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSpeakerDetails = async speakerId => {
  try {
    const speakersDetails = await axios.get(`${SPEAKER_DETAILS_API}/speaker-details/${speakerId}`);
    const data =
      typeof speakersDetails.data === 'string'
        ? JSON.parse(speakersDetails.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
        : speakersDetails.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTalkDetails = async talkId => {
  try {
    const talkDetails = await axios.get(`${TALK_DETAILS_API}/talk-details/${talkId}`);
    const data =
      typeof talkDetails.data === 'string'
        ? JSON.parse(talkDetails.data.replace(/(?:\r\n\t|\r|\n|\t)/g, ' '))
        : talkDetails.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
};
